/*
 * hotel-picker-tracking.js
 * Click tracking for the PDP depth / size / colour picker and the size guide.
 *
 * Spec: "2026-09-19 pdp-picker-click-tracking-spec.md". Invisible to customers;
 * adds no blocking request. Switched off by unchecking "Track picker clicks"
 * on the hotel-main-product section (default on) — with it off the config block
 * is never rendered and this file returns immediately.
 *
 * Route A: gtag() is already on the page from Shopify's Google & YouTube
 * channel app, and theme-code gtag calls are proven to reach GA4 (video_start,
 * view_cart and email_signup all arrive today). We deliberately do NOT publish
 * through Shopify.analytics as well — two routes would double-count.
 *
 * Events, each also carrying product_handle and product_id. No personal data:
 *   depth_select     depth, tap_count
 *   depth_switch     depth_from, depth_to, switch_count     <- defines a switcher
 *   size_select      size, depth, tap_count, picker_type
 *   colour_select    colour, tap_count, picker_type
 *   size_guide_open  size_guide_source
 *
 * Counters are per page view and start at 1. On the first depth_switch we also
 * tag the Clarity session (depth_switcher=yes) and call clarity("upgrade") so
 * switcher sessions are prioritised for recording.
 *
 * Add ?hotel_debug=1 to the URL to send debug_mode with every event: they then
 * appear in GA4's DebugView (Admin > Data display > DebugView) and are kept OUT
 * of standard reports, so test taps never pollute production data. Does nothing
 * without the parameter, so it is safe to leave in permanently.
 *
 * Two things worth knowing if you change this:
 *
 * 1. Depth is normalised from the picker's SKU-derived std/deep to
 *    standard/deepbase, for readability in GA4 reports.
 * 2. size_guide_open must fire ONCE. hotel-size-guide.js opens the accordion
 *    programmatically when either link is clicked, which also fires the
 *    accordion's own toggle event — so a link click is recorded, then the
 *    toggle that follows it is suppressed.
 */
(function () {
  var cfgEl = document.getElementById('hotel-picker-tracking-config');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.handle) return;

  var DEBUG = false;
  try {
    DEBUG = new URLSearchParams(window.location.search).get('hotel_debug') === '1';
  } catch (e) {}

  var DEPTH_NAMES = { std: 'standard', deep: 'deepbase' };
  var counts = { depth: 0, size: 0, colour: 0, switch: 0 };
  var suppressAccordionUntil = 0;

  function depthName(raw) {
    return raw ? DEPTH_NAMES[raw] || raw : undefined;
  }

  function track(name, params) {
    var payload = { product_handle: cfg.handle, product_id: cfg.id };
    if (DEBUG) payload.debug_mode = true;
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined) {
        payload[k] = params[k];
      }
    }
    try {
      if (typeof gtag === 'function') gtag('event', name, payload);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) {}
  }

  function host(el) {
    return el.closest('hotel-depth-size');
  }

  function pickerType(el) {
    var h = host(el);
    if (!h) return undefined;
    if (h.querySelector('[data-depth-btn]')) return 'depth_size';
    if (h.classList.contains('hotel-multi-pills')) return 'multi_pills';
    if (h.querySelector('[data-colour]')) return 'colour';
    return 'single_size';
  }

  function sizeGuideOpened(source) {
    suppressAccordionUntil = Date.now() + 1500;
    track('size_guide_open', { size_guide_source: source });
  }

  document.addEventListener(
    'click',
    function (event) {
      var depthBtn = event.target.closest('[data-depth-btn]');
      if (depthBtn) {
        var h = host(depthBtn);
        var to = depthName(depthBtn.dataset.depthBtn);
        var from = h ? depthName(h.dataset.activeDepth) : undefined;

        counts.depth += 1;
        track('depth_select', { depth: to, tap_count: counts.depth });

        if (from && to && from !== to) {
          counts.switch += 1;
          track('depth_switch', {
            depth_from: from,
            depth_to: to,
            switch_count: counts.switch
          });
          if (counts.switch === 1) {
            try {
              if (typeof window.clarity === 'function') {
                window.clarity('set', 'depth_switcher', 'yes');
                window.clarity('upgrade', 'depth switch');
              }
            } catch (e) {}
          }
        }
        return;
      }

      if (event.target.closest('[data-hotel-size-guide]')) {
        sizeGuideOpened('picker_link');
        return;
      }

      var link = event.target.closest('a[href]');
      if (link && (link.getAttribute('href') || '').split('#')[1] === 'size-guide') {
        sizeGuideOpened('content_link');
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[type="radio"]');
    if (!input || !host(input)) return;

    if (input.dataset.colour !== undefined) {
      counts.colour += 1;
      track('colour_select', {
        colour: input.dataset.colour,
        tap_count: counts.colour,
        picker_type: pickerType(input)
      });
      return;
    }

    var size = input.dataset.size || input.dataset.sizeFull;
    if (!size) return;

    var h = host(input);
    counts.size += 1;
    track('size_select', {
      size: size,
      depth: depthName(input.dataset.depth) || depthName(h && h.dataset.activeDepth),
      tap_count: counts.size,
      picker_type: pickerType(input)
    });
  });

  document.querySelectorAll('.product__accordion details').forEach(function (d) {
    var title = d.querySelector('summary .accordion__title, summary h2, summary');
    if (!title || title.textContent.trim().toLowerCase().indexOf('size guide') === -1) return;
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      if (Date.now() < suppressAccordionUntil) return;
      track('size_guide_open', { size_guide_source: 'accordion' });
    });
  });
})();
